export const enum NWSectionType {
  SECTION = "section",
  PRO = "pro",
  EXTRA_TASK = "extra-task",
}

export const enum NWSectionStatus {
  LOCKED = "locked",
  UNLOCKED = "unlocked",
}

type NWSectionBaseProps = {
  id: string;
};

export type SectionVariantProps = {
  type: NWSectionType.SECTION;
  /**
   * The id to give the child step.
   */
  stepid: string;
  /**
   * The heading text of the section.
   */
  heading: string;
  /**
   * The name of the section, shown within the divider
   */
  name: string;
  /**
   * Whether the section is open or not.
   * @default true
   */
  isopen: boolean;
} & NWSectionBaseProps;

export type ProVariantProps = {
  type: NWSectionType.PRO;
  /**
   * The status of the section. Used to determine if the section is locked or not.
   */
  status: NWSectionStatus;
  /**
   * For PRO sections, this matches the filename of the markdown file to be retrieved from the backend.
   */
  contentId?: string;
} & NWSectionBaseProps;

export type ExtraTaskVariantProps = {
  type: NWSectionType.EXTRA_TASK;
  /**
   * Whether the section is open or not.
   * @default false
   */
  isopen: boolean;
  /**
   * The step id that the extra task belongs to.
   */
  stepid: string;
} & NWSectionBaseProps;

export type NWSectionProps = SectionVariantProps | ProVariantProps | ExtraTaskVariantProps;

export function isSectionVariant(props: NWSectionProps): props is SectionVariantProps {
  return props.type === NWSectionType.SECTION;
}

export function isProVariant(props: NWSectionProps): props is ProVariantProps {
  return props.type === NWSectionType.PRO;
}

export function isExtraTaskVariant(props: NWSectionProps): props is ExtraTaskVariantProps {
  return props.type === NWSectionType.EXTRA_TASK;
}
